import cx from 'classnames';
import ComponentHeader from './component-header';

// do not show empty items + do not forget rebase to another branch
const FormElementWrapper = props => {
  const { children, style, isBuilder = false, editing = false, onClick } = props;

  const additionalBuilderStyles = isBuilder
    ? { borderColor: 'rgba(227, 227, 227, 1)', padding: 16 }
    : {};

  const handleClick = e => {
    if (onClick) {
      // Prevent triggering onClick when clicking on buttons, links, or other interactive elements
      if (e.target.closest('button, a, input, textarea, select')) {
        return;
      }
      onClick(e);
    }
  };

  return (
    <div
      onClick={handleClick}
      data-anchor={props?.data?.id}
      style={{ ...style, ...additionalBuilderStyles }}
      className={cx('SortableItem rfb-item bg-white', {
        'border rounded-lg overflow-hidden': isBuilder,
        'flex gap-2 justify-between items-start': editing,
      })}
    >
      {isBuilder && <ComponentHeader {...props} />}
      <div className={cx('pt-3', { 'flex-1': editing })}>{children}</div>
    </div>
  );
};

export default FormElementWrapper;
